export default __webpack_public_path__ + "static/media/news.33e791ad.png";